module.exports = __webpack_public_path__ + "4ace59919210550d5de86fe01f7e1704.svg";